import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import uniqueId from 'lodash/uniqueId';
import { Input, AlertNotice } from 'shared/components';
import Cleave from 'cleave.js/react';

const PersonForm = (props) => {
  const { t } = useTranslation();

  return (
    <div className="additional-person-form">
      {!!props.errorUpdate && <AlertNotice type="error" message={props.errorUpdate} />}
      <Input
        type="checkbox"
        name="checkAlternate"
        id="checkAlternate"
        key={uniqueId('checklist-item-')}
        checked={props.checkedAlternate}
        onChange={props.setAlternateContact}
        disabled={props.disabledAlternate}>
        <label htmlFor="checkAlternate">
          {t('testCenter.storage.useAlternateContact')}
          {props.disabledAlternate && (
            <span> {t('testCenter.storage.useAlternateContactOnce')}</span>
          )}
        </label>
      </Input>
      <div className="form-inputs">
        <div className="name-form-container">
          <Input
            type="text"
            name="lastName"
            id="UserProfileLastName"
            label="forms.labels.lastName"
            value={props.currentPerson.lastName}
            onChange={props.onChange}
            errors={props.errors.lastName}
            disabled={props.checkedAlternate}
            required
          />
          <Input
            type="text"
            name="firstName"
            id="UserProfileFirstName"
            value={props.currentPerson.firstName}
            label="forms.labels.firstName"
            onChange={props.onChange}
            disabled={props.checkedAlternate}
            errors={props.errors.firstName}
            required
          />
        </div>
        <div className="input-container w-75">
          <label htmlFor="UserProfileCellPhone" className="fw-bold">
            {t('forms.labels.phoneNumber')} ({t('common.labels.optional')})
          </label>
          <Cleave
            name="phone"
            id="UserProfileCellPhone"
            options={{
              phone: true,
              phoneRegionCode: 'US',
              delimiter: '-',
            }}
            value={props.currentPerson.phone}
            onChange={props.onPhoneChange}
            disabled={props.checkedAlternate}
          />
          {props.errors.phone &&
            props.errors.phone.map((error) => (
              <span className="text-error text-small" key={error}>
                {t(error)}
              </span>
            ))}
        </div>
        <Input
          size="w-100"
          type="email"
          name="emailAddress"
          value={props.currentPerson.emailAddress}
          onChange={props.onChange}
          label={`${t('common.labels.email')} (${t('common.labels.optional')})`}
          disabled={props.checkedAlternate}
          errors={props.errors.emailAddress}
        />
      </div>
    </div>
  );
};

export default PersonForm;

PersonForm.propTypes = {
  errors: PropTypes.shape({}),
  errorUpdate: PropTypes.string,
  currentPerson: PropTypes.shape({}).isRequired,
  onPhoneChange: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  setAlternateContact: PropTypes.func.isRequired,
  checkedAlternate: PropTypes.bool.isRequired,
  disabledAlternate: PropTypes.bool,
};
